import { convertToFloat } from './convertToFloat'
import type { ValidationItem } from '../contexts/zustand/onboarding'

const PRODUCT_ID_OCR_DOCUMENTOS = process.env.REACT_APP_PRODUCT_ID_OCR_DOCUMENTOS
const PRODUCT_ID_CNH_SERPRO = process.env.REACT_APP_PRODUCT_ID_CNH_SERPRO

export function validationMapper(
  priceProducts: any[],
  filterMapping: Record<string, string>
): Record<string, ValidationItem[]> {
  const result: Record<string, ValidationItem[]> = {};
  // encontra o OCR para adicionar ao CNH
  const ocr = priceProducts.find(
    (p) => p.product__id === PRODUCT_ID_OCR_DOCUMENTOS
  );

  Object.entries(filterMapping).forEach(([key, valOnb]) => {
    result[key] = priceProducts
      .filter((p) => p.validation_onboarding === valOnb)
      .map((p) => {
        let price = p.price;
        if (p.product__id === PRODUCT_ID_CNH_SERPRO && ocr) {
          const sum =
            convertToFloat(price) + convertToFloat(ocr.price);
          price = sum.toFixed(2).replace('.', ',');
        }
        return {
          id:          p.product__id,
          name:        p.product__name,
          price,
          description: p.product__description,
          available:   p.available,
          category:    p.product__category,
        };
      });
  });

  return result;
}